var map = {
	"./icons/accountSettings.svg": 7114,
	"./icons/add.svg": 1645,
	"./icons/advertisements.svg": 5920,
	"./icons/advertisements_active.svg": 4040,
	"./icons/arrow_left.svg": 4651,
	"./icons/arrow_right.svg": 8266,
	"./icons/arrow_right_background.svg": 7831,
	"./icons/arrow_right_blue.svg": 1736,
	"./icons/back_black.svg": 5788,
	"./icons/bell.svg": 3643,
	"./icons/calendar.svg": 1421,
	"./icons/caret_down.svg": 4951,
	"./icons/caret_down_black.svg": 3534,
	"./icons/caret_left.svg": 9737,
	"./icons/caret_right.svg": 2991,
	"./icons/check.svg": 4687,
	"./icons/close.svg": 2479,
	"./icons/cluster.svg": 394,
	"./icons/dashboard.svg": 8554,
	"./icons/delete.svg": 2474,
	"./icons/desc.svg": 1538,
	"./icons/download.svg": 7910,
	"./icons/edit.svg": 9911,
	"./icons/edit_new.svg": 497,
	"./icons/editions.svg": 7426,
	"./icons/editions_active.svg": 3893,
	"./icons/error.svg": 7211,
	"./icons/error_red.svg": 341,
	"./icons/header_success.svg": 6814,
	"./icons/home.svg": 1164,
	"./icons/home_active.svg": 344,
	"./icons/houses.svg": 6390,
	"./icons/id.svg": 6250,
	"./icons/image.svg": 4160,
	"./icons/info.svg": 9932,
	"./icons/info_white.svg": 8749,
	"./icons/knowledge.svg": 4125,
	"./icons/logo.svg": 1204,
	"./icons/logout.svg": 230,
	"./icons/logout_active.svg": 1329,
	"./icons/maximize.svg": 7878,
	"./icons/menu_burger.svg": 8665,
	"./icons/message.svg": 5686,
	"./icons/moon.svg": 6799,
	"./icons/my_advertisements.svg": 587,
	"./icons/my_advertisements_active.svg": 5132,
	"./icons/myaccount.svg": 8706,
	"./icons/myaccount_active.svg": 7232,
	"./icons/netplan.svg": 9177,
	"./icons/old_editions.svg": 6853,
	"./icons/old_editions_active.svg": 1190,
	"./icons/password.svg": 4134,
	"./icons/print.svg": 5857,
	"./icons/read.svg": 1766,
	"./icons/rename.svg": 9696,
	"./icons/search.svg": 2661,
	"./icons/selectTriangle.svg": 5681,
	"./icons/settings.svg": 3047,
	"./icons/settings_active.svg": 3982,
	"./icons/sort_dots.svg": 9067,
	"./icons/statistics.svg": 9305,
	"./icons/success.svg": 735,
	"./icons/sun.svg": 5938,
	"./icons/text.svg": 5987,
	"./icons/ticket.svg": 7870,
	"./icons/tickets.svg": 4549,
	"./icons/times.svg": 2565,
	"./icons/user.svg": 2327,
	"./icons/users.svg": 8178,
	"./icons/users_active.svg": 5871,
	"./icons/warning.svg": 5561,
	"./image_mark.svg": 9564
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7234;